import type { SVGProps } from "react";
export function OpenDetailsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={12}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 12 12"
      width={12}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.75 5.75h-10m5 5v-10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
